import React, { useState, useEffect } from 'react';
import api from '../api';
import Loader from './Loader';

const OdometerForm = ({ onOdometerAdded }) => {
  const [formData, setFormData] = useState({
    vehicle_no: '',
    reading_date: new Date().toISOString().slice(0, 10),
    odometer_value: '',
    can_data: '',
  });
  const [vehicles, setVehicles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await api.get('/vehicles');
        setVehicles(response.data);
        if (response.data.length > 0) {
          setFormData((prev) => ({
            ...prev,
            vehicle_no: response.data[0].vehicle_no,
          }));
        }
      } catch (error) {
        console.error('Error fetching vehicles:', error);
      }
    };
    fetchVehicles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const manualReading = parseInt(formData.odometer_value, 10) || 0;
      const canReading = parseInt(formData.can_data, 10) || 0;
      const finalOdometerValue = Math.max(manualReading, canReading);

      await api.post('/odometer', {
        ...formData,
        odometer_value: finalOdometerValue,
        vehicle_numbers: [formData.vehicle_no],
      });
      alert('Odometer reading submitted successfully!');
      if (onOdometerAdded) {
        onOdometerAdded();
      }
      setFormData({
        vehicle_no: vehicles.length > 0 ? vehicles[0].vehicle_no : '',
        reading_date: new Date().toISOString().slice(0, 10),
        odometer_value: '',
        can_data: '',
      });
    } catch (error) {
      console.error(
        'Error submitting odometer reading:',
        error.response ? error.response.data : error.message,
      );
      alert(
        `Error: ${error.response ? error.response.data.message : error.message}`,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 bg-white dark:bg-gray-800 h-full overflow-y-auto">
      {isSubmitting && <Loader />}
      <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">
        Add Odometer Reading
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Vehicle Number
          </label>
          <select
            name="vehicle_no"
            value={formData.vehicle_no}
            onChange={handleChange}
            required
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            disabled={isSubmitting}
          >
            {vehicles.map((vehicle) => (
              <option key={vehicle.id} value={vehicle.vehicle_no}>
                {vehicle.vehicle_no}
              </option>
            ))}
          </select>
        </div>
        <InputField
          label="Reading Date"
          name="reading_date"
          type="date"
          value={formData.reading_date}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <InputField
          label="Manual Odometer (km)"
          name="odometer_value"
          type="number"
          value={formData.odometer_value}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        <InputField
          label="CAN Data (km)"
          name="can_data"
          type="number"
          value={formData.can_data}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        <div className="pt-6">
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Reading'}
          </button>
        </div>
      </form>
    </div>
  );
};

const InputField = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {label}
    </label>
    <input
      {...props}
      className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>
);

export default OdometerForm;
